import { useState } from "react"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"
import { SmallText } from "./typography/Typography"

type AccordionItem = {
    id: string
    title: string
    content: JSX.Element
}

type Props = {
    items: AccordionItem[]
}

export const Accordion = ({ items }: Props) => {
    const [openId, setOpenId] = useState<string | null>(null)

    const toggle = (id: string) => {
        setOpenId((prev) => (prev === id ? null : id))
    }

    return (
        <div className="flex flex-col gap-3 w-full lg:hidden">
            {items.map((item) => {
                const isOpen = openId === item.id

                return (
                    <div
                        key={item.id}
                        className="overflow-hidden transition-all border-b border-dark-3"
                    >
                        {/* Header */}
                        <button
                            onClick={() => toggle(item.id)}
                            className="w-full flex items-center justify-between px-4 md:px-6 py-4 text-left transition-all"
                        >
                            <SmallText className="font-light">
                                {item.title}
                            </SmallText>

                            <ChevronDownIcon
                                className={twMerge(
                                    "size-5 text-gray-500 transition-transform duration-300",
                                    isOpen && "rotate-180 text-my-orange"
                                )}
                            />
                        </button>

                        {/* Content */}
                        <div
                            className={twMerge(
                                "grid transition-all duration-300 ease-in-out",
                                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                            )}
                        >
                            <div className="overflow-hidden">
                                <div className="px-4 md:px-6 pb-4">
                                        {item.content}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}